import {
  DRIVER_GET_STATE_DATA,
  GET_LIST_DRIVER,
  GET_LIST_DRIVER_REQUEST,
  INVITE_DRIVER_FAILURE,
  INVITE_DRIVER_REQUEST,
  INVITE_DRIVER_SUCCESS,
} from "../constants";

const INITIAL_STATE = {
  stateObject: {},
  isLoading: false,
  inviteDriverData: {},
  driverList: [],
};

const driverReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INVITE_DRIVER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case INVITE_DRIVER_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case INVITE_DRIVER_SUCCESS:
      return {
        ...state,
        inviteDriverData: action.payload,
        isLoading: false,
      };
    case GET_LIST_DRIVER_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
      };
    case GET_LIST_DRIVER:
      return {
        ...state,
        driverList: action.payload,
        isLoading: false,
      };
    case DRIVER_GET_STATE_DATA:
      return {
        ...state,
        stateObject: action.payload,
      };
    default:
      return state;
  }
};

export default driverReducer;
